export const bidsData = [
  {
    id: 1,
    bid: '001',
    crop: 'in tortor feugiat dolor set am',
    bidDate: '01/04/2021',
    perKGRate: '509.00',
    negiotiate: '559.00',
    status: 'active',
  },{
    id: 1,
    bid: '001',
    crop: 'in tortor feugiat dolor set am',
    bidDate: '01/04/2021',
    perKGRate: '609.00',
    negiotiate: '559.00',
    status: 'active',
  },{
    id: 1,
    bid: '001',
    crop: 'in tortor feugiat dolor set am',
    bidDate: '01/04/2021',
    perKGRate: '559.00',
    negiotiate: '559.00',
    status: 'active',
  },{
    id: 1,
    bid: '001',
    crop: 'in tortor feugiat dolor set am',
    bidDate: '01/04/2021',
    perKGRate: '559.00',
    negiotiate: '559.00',
    status: 'active',
  },{
    id: 1,
    bid: '001',
    crop: 'in tortor feugiat dolor set am',
    bidDate: '01/04/2021',
    perKGRate: '559.00',
    negiotiate: '559.00',
    status: 'active',
  },{
    id: 1,
    bid: '001',
    crop: 'in tortor feugiat dolor set am',
    bidDate: '01/04/2021',
    perKGRate: '559.00',
    negiotiate: '559.00',
    status: 'active',
  },
]

export const bidsHeadCells = [
  {id: "bidId", numeric: false, disablePadding: true, label: "bid#"},
  {id: "crop", numeric: false, disablePadding: false, label: "crop"},
  {id: "name", numeric: false, disablePadding: false, label: "Bidder Name",},
  {id: "perKGRate", numeric: true, disablePadding: false, label: "per Unit Rate"},
  {id: "quantity", numeric: false, disablePadding: false, label: "quantity"},
  // {id: "totalQuantityBid", numeric: false, disablePadding: false, label: "Bid Price"},
  {id: "businessName", numeric: false, disablePadding: false, label: "Business Name"},
  {id: "action", numeric: true, disablePadding: false, label: "actions"},
];
export const bidsHeadCellsSmart = [
 {id: "bidId", numeric: false, disablePadding: true, label: "bid#"},
  {id: "crop", numeric: false, disablePadding: false, label: "crop"},
  {id: "name", numeric: false, disablePadding: false, label: "Bidder Name",},
  {id: "perKGRate", numeric: true, disablePadding: false, label: "per Unit Rate"},
  {id: "quantity", numeric: false, disablePadding: false, label: "quantity"},
  // {id: "totalQuantityBid", numeric: false, disablePadding: false, label: "Bid Price"},
  {id: "businessName", numeric: false, disablePadding: false, label: "Business Name"}
];
